// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"_40d5d0e87d--fullscreen--PrFzo"};